import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  touristplans: any[];

  constructor() { }

  ngOnInit(): void {

    this.touristplans = [
      {
        mainPhoto: "",
        galleryPhotos: ["", ""],
        title: "SAN ANDRES EL MAR DE LOS 7 COLORES",
        subtitle: "Paquete básico – Temporada baja",
        description: "Alojamiento 04 noches en el HOTEL CASA BLANCA VISTA INTERNA, Un adulto en acomodación doble",
        adultCost:2699000,
        costChild: 18990000,
        ageChildren:{
            min: 2,
            max: 10,
        },
        accommodation:"Doble",
        airTicketInformation: {
          airline: "Viva Air",
          roundTrip: true,
          baggage:
          {
            handBaggage: 10,
            holdBaggage: 20,
          }
        },
        viewInHotel:"Interna",
        hotel:"Hotel Casa Blanca",
        servicesIncluded: ["Traslados aeropuerto – hotel – aeropuerto", "Seguro hotelero"],
        medicalAssistanceCard: true,
        food: ["desayuno", "almuerzo", "cena"],
        snack: true,
        snackConditions: "Horarios establecidos por el hotel",
        drinks: true,
        unlimitedDrinks: true,
        drinkConditions: "Horarios establecidos por el hotel",
        tours: ["Jhonny Cay o Rocky Cay.", "Vuelta a la isla terrestre.", "Tour bahía diurno."],
        lowSeason: true,
        servicesNotIncluded: [
          {
            title: "Gastos no especificados",
            description: ""
          },
          {
            title: "Impuestos ecológicos",
            description: "Aprox $35.000"
          },
          {
            title: "Tarjeta de ingreso a la isla $118.700",
            description: "Costo $118.700"
          }
        ],
        toConsider: [
          "Infante de 0 a 12 meses paga asistencia médica y seguro hotelero $70.000",
          "Alojamiento 4 noches por Niñ@s de 02 a 10 años $1’899.0000",
          "Salidas en solo en fechas programadas",
          "Tarifas sujetas a cambios sin previo aviso y a disponibilidad al momento de reservar"
        ]
      }
    ]
  }

}
